import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HaccpPictureTraceability = lazy(
  () => import("@/pages/haccp/picture-traceability/HaccpPictureTraceability"),
);
const HaccpPictureTraceabilityLayout = lazy(
  () =>
    import("@/pages/haccp/picture-traceability/HaccpPictureTraceabilityLayout"),
);
const DayView = lazy(
  () => import("@/pages/haccp/picture-traceability/components/day/DayView"),
);
const MonthView = lazy(
  () => import("@/pages/haccp/picture-traceability/components/month/MonthView"),
);

export const pictureTraceabilityRoutes: RouteObject[] = [
  {
    path: "/haccp/picture-traceability",
    element: <HaccpPictureTraceability />,
    children: [
      {
        path: "domain/:domainId",
        element: <HaccpPictureTraceabilityLayout />,
        children: [
          {
            path: "site/:siteId/day/:date",
            element: <DayView />,
          },
          {
            path: "month/:date",
            element: <MonthView />,
          },
        ],
      },
    ],
  },
];
